module.exports = __webpack_public_path__ + "img/Doc17a_Poppy-Campaign-ad.deba82b7.jpg";